if (!customElements.get('slide-show')) {
  class Slideshow extends HTMLElement {
    constructor() {
      super();
      this.swiperPrev = null;
      this.swiperNext = null;
      this.swiperPagination = null;
      this.swiperContainer = null;
      this.swiperScrollbar = null;
      this.slideshowSwiper = null;
    }

    connectedCallback() {
      this.swiperPrev = this.querySelector('.swiper-button-prev');
      this.swiperNext = this.querySelector('.swiper-button-next');
      this.swiperPagination = this.querySelector('.swiper-pagination');
      this.swiperContainer = this.querySelector('.swiper-container');
      this.swiperScrollbar = this.querySelector('.swiper-scrollbar');
      this.slideItems = this.querySelectorAll('.swiper-slide');

      if (this.swiperContainer) {
        this.initSwiper();
      }
      if (this.slideItems.length > 1) {
        this.slideClickHandler();
      }
    }

    initSwiper() {
      const autoplay = this.getAttribute('data-autoplay') === 'true';
      const loop = this.getAttribute('loop')=== 'true' ? true : false;
      const autoplayDelay = Number(this.getAttribute('data-autoplay-delay')) || 3000;

      const swiperOptions = {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: loop,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: this.swiperNext,
          prevEl: this.swiperPrev,
        },
        pagination: {
          el: this.swiperPagination,
          clickable: true,
        },
        scrollbar: {
          el: this.swiperScrollbar,
        },
      };

      if (autoplay) {
        swiperOptions.autoplay = {
          delay: autoplayDelay,
          disableOnInteraction: false,
        };
      }

      this.slideshowSwiper = new Swiper(this.swiperContainer, swiperOptions);
    }

    slideClickHandler() {
      this.slideItems.forEach(item => {
        item.addEventListener('click', (e) => {
          const link = item.dataset.link;
          if (link) {
            window.location.href = link;
          }
        })
      })
    }
  }

  customElements.define('slide-show', Slideshow);
}


const slideshowElement = document.querySelector('.new-slideshow .swiper-wrapper');
if (slideshowElement && slideshowElement.dataset.height === 'true') {
  const updateMaxHeight = () => {
    const ratio = window.innerWidth > 849 ? 2.5 : 0.67;
    const maxHeightInPx = (window.innerWidth / ratio);
    slideshowElement.style.maxHeight = `${maxHeightInPx}px`;
  };

  updateMaxHeight();

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateMaxHeight, 200);
  });
}